import { getAvatarUrl } from '@/lib/image'
import { getEnvConfig } from '@/lib/runtime-env'

interface CallUserProfileProps {
  avatar?: string
  className?: string
  name: string
  subtitle: string
}

function displayInitial(name: string) {
  return name.trim().slice(0, 1) || 'U'
}

export function CallUserProfile({ avatar, className, name, subtitle }: CallUserProfileProps) {
  const avatarUrl = getAvatarUrl(avatar, getEnvConfig().CDN_URL)

  return (
    <section className={`call-surface-profile${className ? ` ${className}` : ''}`}>
      {avatarUrl ? (
        <img className="call-surface-avatar" alt="" src={avatarUrl} />
      ) : (
        <div className="call-surface-avatar call-surface-avatar-fallback" aria-hidden="true">
          {displayInitial(name)}
        </div>
      )}
      <h2>{name}</h2>
      <p>{subtitle}</p>
    </section>
  )
}
